// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}/${sublink}`;
}

const ROOTS = '/';
const ROOTS_AUTH = '/auth';
const ROOTS_ONLINE = '/online';
const ROOTS_CONTACT_CENTER = '/contactcenter';
const ROOTS_NAVIGATION = '..';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
};
//----------------------------------------------------------------
//** Online */
export const PATH_ONLINE_SUB = {
  root: ROOTS_ONLINE,
  accept: 'accept',
  contact: 'contact',
  gettingStarted: 'getting-started',
  cover: 'cover',
  quote: 'quote',
  saveAndEmail: 'save-and-email',
  aboutYouInformation: 'about-you-information',
  aboutYouDeclarations: 'about-you-declarations',
  aboutYouDisclosure: 'about-you-disclosure',
  aboutYouQuestions: 'about-you-questions',
  aboutYourReview: 'review-application',
  ppContact: 'payment-contact',
  ppOnlinePayment: 'payment-detail',
  ppConfirmation: 'payment-confirmation',
  ppOnlinePolicyOutcome: 'policy-outcome',
  ppPolicyOutcomeDecline: 'policy-outcome-decline',
  retrieveQuote: 'retrieve-quote',
  retrieveQuoteLoading: 'retrieve-quote-loading',
  retrieveDecline: 'retrieve-decline',
  retrieveExpired: 'retrieve-expired',
  retrieveReferredUW: 'retrieve-referred-uw',
  retrieveBound: 'retrieve-bound',
  applicationAlreadyDeclined: 'application-declined',
};

export const PATH_ONLINE = {
  root: ROOTS_ONLINE,
  accept: path(ROOTS_ONLINE, PATH_ONLINE_SUB.accept),
  contact: path(ROOTS_ONLINE, PATH_ONLINE_SUB.contact),
  gettingStarted: path(ROOTS_ONLINE, PATH_ONLINE_SUB.gettingStarted),
  cover: path(ROOTS_ONLINE, PATH_ONLINE_SUB.cover),
  quote: path(ROOTS_ONLINE, PATH_ONLINE_SUB.quote),
  saveAndEmail: path(ROOTS_ONLINE, PATH_ONLINE_SUB.saveAndEmail),
  aboutYouInformation: path(ROOTS_ONLINE, PATH_ONLINE_SUB.aboutYouInformation),
  aboutYouDeclarations: path(ROOTS_ONLINE, PATH_ONLINE_SUB.aboutYouDeclarations),
  ppContact: path(ROOTS_ONLINE, PATH_ONLINE_SUB.ppContact),
  ppOnlinePayment: path(ROOTS_ONLINE, PATH_ONLINE_SUB.ppOnlinePayment),
  ppConfirmation: path(ROOTS_ONLINE, PATH_ONLINE_SUB.ppConfirmation),
  ppOnlinePolicyOutcome: path(ROOTS_ONLINE, PATH_ONLINE_SUB.ppOnlinePolicyOutcome),
  retrieveQuote: path(ROOTS_ONLINE, PATH_ONLINE_SUB.retrieveQuote),
  ppPolicyOutcomeDecline: path(ROOTS_ONLINE, PATH_ONLINE_SUB.ppPolicyOutcomeDecline),
  retrieveQuoteLoading: path(ROOTS_ONLINE, PATH_ONLINE_SUB.retrieveQuoteLoading),
  retrieveDecline: path(ROOTS_ONLINE, PATH_ONLINE_SUB.retrieveDecline),
  retrieveExpired: path(ROOTS_ONLINE, PATH_ONLINE_SUB.retrieveExpired),
  retrieveBound: path(ROOTS_ONLINE, PATH_ONLINE_SUB.retrieveBound),
};

export const PATH_ONLINE_NAVIGATION = {
  accept: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.accept),
  contact: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.contact),
  gettingStarted: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.gettingStarted),
  cover: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.cover),
  quote: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.quote),
  saveAndEmail: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.saveAndEmail),
  aboutYouInformation: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.aboutYouInformation),
  aboutYouDeclarations: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.aboutYouDeclarations),
  ppContact: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.ppContact),
  ppOnlinePayment: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.ppOnlinePayment),
  ppConfirmation: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.ppConfirmation),
  ppOnlinePolicyOutcome: path(ROOTS_NAVIGATION, PATH_ONLINE_SUB.ppOnlinePolicyOutcome),
};

//* ----------------------------------------------------------------
//** Contact Center */
export const PATH_CONTACT_CENTER_SUB = {
  root: ROOTS_CONTACT_CENTER,
  openingScript: 'openingScript',
  contact: 'contact',
  gettingStarted: 'getting-started',
  cover: 'cover',
  quote: 'quote',
  saveAndEmail: 'save-and-email',
  aboutYouInformation: 'about-you-information',
  aboutYouDeclarations: 'about-you-declarations',
  aboutYouDisclosure: 'about-you-disclosure',
  aboutYouQuestions: 'about-you-questions',
  aboutYourReview: 'review-application',
  ppContact: 'payment-contact',
  ppCCPayment: 'payment-detail',
  ppConfirmation: 'payment-confirmation',
  ppCCPolicyOutcome: 'policy-outcome',
  ppPolicyOutcomeDecline: 'policy-outcome-decline',
  upgradeSaveConfirmation: 'upgrade-save-confirmation',
  landingPage: 'landing-page',
  retrieveQuote: 'retrieve-quote',
  retrieveQuoteLoading: 'retrieve-quote-loading',
  retrieveDecline: 'retrieve-decline',
  retrieveExpired: 'retrieve-expired',
  retrieveReferredUW: 'retrieve-referred-uw',
  retrieveBound: 'retrieve-bound',
  applicationAlreadyDeclined: 'application-declined',
};

export const PATH_CONTACT_CENTER = {
  root: ROOTS_CONTACT_CENTER,
  openingScript: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.openingScript),
  contact: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.contact),
  gettingStarted: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.gettingStarted),
  cover: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.cover),
  quote: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.quote),
  saveAndEmail: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.saveAndEmail),
  aboutYouInformation: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.aboutYouInformation),
  aboutYouDeclarations: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.aboutYouDeclarations),
  ppContact: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.ppContact),
  ppCCPayment: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.ppCCPayment),
  ppConfirmation: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.ppConfirmation),
  ppCCPolicyOutcome: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.ppCCPolicyOutcome),
  ppPolicyOutcomeDecline: path(
    ROOTS_CONTACT_CENTER,
    PATH_CONTACT_CENTER_SUB.ppPolicyOutcomeDecline,
  ),
  upgradeSaveConfirmation: path(
    ROOTS_CONTACT_CENTER,
    PATH_CONTACT_CENTER_SUB.upgradeSaveConfirmation,
  ),
  landingPage: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.landingPage),
  retrieveQuote: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.retrieveQuote),
  aboutYouDisclosure: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.aboutYouDisclosure),
  aboutYourReview: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.aboutYourReview),
  retrieveQuoteLoading: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.retrieveQuoteLoading),
  retrieveDecline: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.retrieveDecline),
  retrieveExpired: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.retrieveExpired),
  retrieveBound: path(ROOTS_CONTACT_CENTER, PATH_CONTACT_CENTER_SUB.retrieveBound),
};

export const PATH_CONTACT_CENTER_NAVIGATION = {
  openingScript: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.openingScript),
  contact: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.contact),
  gettingStarted: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.gettingStarted),
  cover: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.cover),
  quote: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.quote),
  saveAndEmail: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.saveAndEmail),
  aboutYouInformation: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.aboutYouInformation),
  aboutYouDeclarations: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.aboutYouDeclarations),
  ppContact: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.ppContact),
  ppCCPayment: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.ppOnlinePayment),
  ppConfirmation: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.ppConfirmation),
  ppCCPolicyOutcome: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.ppCCPolicyOutcome),
  upgradeSaveConfirmation: path(ROOTS_NAVIGATION, PATH_CONTACT_CENTER_SUB.upgradeSaveConfirmation),
};

//----------------------------------------------------------------
//** Shared pages */
export const PATH_SHARED_SUB = {
  infoAndDuty: 'information-and-duty',
};

export const PATH_SHARED = {
  infoAndDuty: path(ROOTS, PATH_SHARED_SUB.infoAndDuty),
};
